import wheelchairIconDark from '../../../../assets/icons/wheelchair-dark.svg';
import wheelchairIconWhite from '../../../../assets/icons/wheelchair-white.svg';
import wheelchairIconBox from '../../../../assets/icons/wheelchair-blue-solid.svg';
import { TranslationService } from '../../../services/translation.service';
import DataUrlHelper from '../../../helpers/data-url.helper';
import { WheelchairIconType } from './wheelchair-icon-type.enum';

function getIcon(iconType: WheelchairIconType): string {
  switch (iconType) {
    case WheelchairIconType.dark:
      return wheelchairIconDark;
    case WheelchairIconType.white:
      return wheelchairIconWhite;
    case WheelchairIconType.box:
      return wheelchairIconBox;
    default:
      return wheelchairIconDark;
  }
}

function WheelchairIcon({ iconType, sizeInRem, className }: { iconType: WheelchairIconType; sizeInRem: number; className?: string }) {
  return (
    <img
      className={className}
      alt={TranslationService.get('common.wheelchairdescription')}
      src={DataUrlHelper.encode(getIcon(iconType))}
      style={{ height: `${sizeInRem}rem`, width: `${sizeInRem}rem` }}
    />
  );
}

export default WheelchairIcon;
